import React, { useEffect,useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getData } from '../../../../ApiServices/ApiService';
import { ORG_GET_TEAM_LIST,ORG_GET_EMPLOYEE_LIST } from '../../../../ApiServices/BaseURL';
import { logFrontendException } from "../../../../Utils/Exception";
import { useTheme } from "../../../../GlobalContext/GlobalContext";

const TeamsUsersManagementController = () => {
    const navigate = useNavigate();
    const [teamList, setTeamList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');  
    const { setIsLoginPopup } = useTheme();
    const [userList, setUserList] = useState([]);
    const [userLoading, setUserLoading] = useState(false);
    const [userError, setUserError] = useState('');  

    const [empList, setEmpList] = useState([]);
    const [empLoading, setEmpLoading] = useState(false);
    const [empError, setEmpError] = useState('');

    const pageName = 'TeamsUsersManagementController';
    const storedUserId = JSON.parse(localStorage.getItem("_userInfo_"))?.emp_id;

    useEffect(()=>{
      const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_') || '{}');
      const { per_name_sub_json } = storedUserInfo?.user_permissions?.emp_mgmt || {};
      if (per_name_sub_json?.manage_emp_add_edit_emp === 1) {
        fetchUserList();
      }
      if (per_name_sub_json?.manage_teams_add_edit_emp === 1) {
        fetchTeamList();
      }
      },[])

    const fetchTeamList =async ()=>{
        try {
            setLoading(true);
            setError('');
            setTeamList([]);


            const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
        
            // Make the API call
            const response = await getData(`${ORG_GET_TEAM_LIST}?emp_id_auth=${storedUserInfo?.emp_id}`);
            const responseData = await response.json();
        
            // Check for success (200) and internal status code
            if (response?.status === 200) {
              if (responseData?.statusCode === 200) {
                if (responseData?.message.toLowerCase() === 'success') {
                  if (responseData?.dataJ?.length > 0) {
                    setTeamList(responseData?.dataJ);
                  } else {
                    setError(responseData?.info || 'Data Not Found');
                    // ⛔️ Log exception to backend (User Id,Page Name,Method Name,Response/error)
                    logFrontendException( storedUserId, pageName, "fetchTeamList", responseData || '');
                  }
                } else {
                  setError(responseData?.info || 'Failed to fetch data. Please try again.');
                  // ⛔️ Log exception to backend (User Id,Page Name,Method Name,Response/error)
                  logFrontendException( storedUserId, pageName, "fetchTeamList", responseData || '');
                }
              } else {
                setError(responseData?.info || 'Something went wrong while processing your request.');
                // ⛔️ Log exception to backend (User Id,Page Name,Method Name,Response/error)
                logFrontendException( storedUserId, pageName, "fetchTeamList", responseData || '');
              }
            } 
            // Token-related errors: 400, 401, 403
            else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
              setError('Unauthorized access. Your session may have expired. Please log in again.');
              setIsLoginPopup(true)
              // ⛔️ Log exception to backend (User Id,Page Name,Method Name,Response/error)
              logFrontendException( storedUserId, pageName, "fetchTeamList-400", responseData || '');
          
            } 
            // Unexpected or network-related errors
            else {
              setError('Unexpected error occurred. Please try again later.');
              // ⛔️ Log exception to backend (User Id,Page Name,Method Name,Response/error)
              logFrontendException( storedUserId, pageName, "fetchTeamList", responseData || '');
            }
          } catch (error) {
            
              setError(`Something went wrong while processing your request. Please check your network connection and try again.`);
              // ⛔️ Log exception to backend (User Id,Page Name,Method Name,Response/error)
              logFrontendException( storedUserId, pageName, "fetchTeamList-catch", error || '');
            
          } finally {
            setLoading(false);
          }
      }

      const fetchUserList =async ()=>{
        try {
          setUserLoading(true);
          setUserError('');
            setUserList([]);

            const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
        
            // Make the API call
            const response = await getData(`${ORG_GET_EMPLOYEE_LIST}?emp_id_auth=${storedUserInfo?.emp_id}`);
            const responseData = await response.json();
        
            // Check for success (200) and internal status code
            if (response?.status === 200) {
              if (responseData?.statusCode === 200) {
                if (responseData?.message.toLowerCase() === 'success') {
                  if (responseData?.dataJ?.length > 0) {
                    setUserList(responseData?.dataJ);
                  } else {
                    setUserError(responseData?.info || 'Data Not Found');
                    logFrontendException( storedUserId, pageName, "fetchUserList", responseData || '');
                  }
                } else {
                  setUserError(responseData?.info || 'Failed to fetch User data. Please try again.');
                  logFrontendException( storedUserId, pageName, "fetchUserList", responseData || '');
                }
              } else {
                setUserError(responseData?.info || 'Failed to fetch User data.');
                logFrontendException( storedUserId, pageName, "fetchUserList", responseData || '');
              }
            } 
            // Token-related errors: 400, 401, 403
            else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
              setUserError('Unauthorized access. Your session may have expired. Please log in again.');
              logFrontendException( storedUserId, pageName, "fetchUserList", response || '');
          
            } 
            // Unexpected or network-related errors
            else {
              setUserError('Unexpected error occurred. Please try again later.');
              logFrontendException( storedUserId, pageName, "fetchUserList", response || '');
            }
          } catch (error) {
           
              // An error occurred in setting up the request
              setUserError(`Failed to fetch User data. Please check your network connection and try again.`);
              logFrontendException( storedUserId, pageName, "fetchUserList", error || '');
           
          } finally {
            setUserLoading(false);
          }
      }

      const refreshTeamList=()=>{
        fetchTeamList();
      }

      const refreshUserList=()=>{
        fetchUserList();
      }

    return {
        teamList,
        error,
        loading,
        refreshTeamList,
        userList,
        userError,
        userLoading,
        refreshUserList
    }

}

export default TeamsUsersManagementController;